import FullWidthCTA from './FullWidthCTA';

export default FullWidthCTA;
